<template>
  <b-container fluid>
    <TopBar id="top-bar" :nom="epreuve.nom_epreuve" :date="epreuve.date_epreuve" :ville="epreuve.ville_competition"
      :id_epreuve="epreuve.id"></TopBar>
    <!-- Permet de filtrer les résultats -->
    <b-row id="selector-bar">
      <b-col sm="12" md="6">
        <SelectionCourse v-if="epreuve.list_courses" :list_courses="epreuve.list_courses" :id_epreuve="epreuve.id">
        </SelectionCourse>
      </b-col>
      <b-col sm="12" md="6">
        <b-row>
          <b-col sm="12" md="4">
            <p class="filter-title">Catégorie</p>
            <b-form-select size="sm" v-model="filterCat" :options="list_cat"></b-form-select>
          </b-col>
          <b-col sm="12" md="4">
            <p class="filter-title">Sexe</p>
            <b-button-group>
              <b-button size="sm" v-on:click="filterSexe = ''" v-bind:class="{ isCurrent: filterSexe === '' }">
                <v-icon name="male" />
                <v-icon name="female" />
              </b-button>
              <b-button size="sm" v-on:click="filterSexe = 'M'" v-bind:class="{ isCurrent: filterSexe === 'M' }">
                <v-icon name="male" />
              </b-button>
              <b-button size="sm" v-on:click="filterSexe = 'F'" v-bind:class="{ isCurrent: filterSexe === 'F' }">
                <v-icon name="female" />
              </b-button>
            </b-button-group>
          </b-col>
          <b-col sm="12" md="4">
            <p class="filter-title">Club</p>
            <b-form-select size="sm" v-model="filterClub" :options="list_clubs"></b-form-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="12" style="margin-top: 5px">
            <b-form-input size="sm" v-model="keyword" placeholder="Rechercher un coureur..."></b-form-input>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- Fourni les stats d'inscriptions ainsi que les boutons pour télécharger la séléction en PDF et CSV -->
    <b-row id="additional-informations-bar">
      <b-col> </b-col>
      <b-col>
        <span class="filter-title">Télécharger cette sélection : </span>
        <b-button-group>
          <b-button v-on:click="downloadCSV" style="margin-right: 5px" size="sm"> <v-icon name="download" />
            CSV</b-button>

          <form v-if="epreuve" :action="$store.getters.base_url + '/files/listing_pdf.php'" method="POST"
            target="_blank">
            <input type="hidden" name="id_epreuve" :value="epreuve.id" />
            <input type="hidden" name="parcours" :value="current_rassemblement" />
            <input type="hidden" name="data" :value="JSON.stringify(this.itemsForPdf())" />
            <b-button type="submit" size="sm"> <v-icon name="download" /> PDF</b-button>
          </form>
        </b-button-group>
      </b-col>
    </b-row>

    <TableauResultats id="tableau-resultats" v-if="!loading && epreuve.resultats.length > 0" :resultats="resultats"
      :fields="epreuve.fields" :courses_challenge="epreuve.selected_challenge" :colored_fields="epreuve.colored_fields"
      :diplome="epreuve.diplome" :nom_epreuve="epreuve.nom_epreuve"></TableauResultats>

    <AttenteResultats v-if="!loading && epreuve.resultats.length < 1"></AttenteResultats>
    <FullScreenLoading v-if="loading" action="Chargement en cours"></FullScreenLoading>
  </b-container>
</template>

<script>
import axios from "axios";
import TopBar from "@/component/Epreuve/TopBar";
import TableauResultats from "@/component/Epreuve/TableauResultats";
import SelectionCourse from "@/component/Epreuve/SelectionCourse";
import FullScreenLoading from "@/component/FullScreenLoading";
import AttenteResultats from "@/component/Epreuve/AttenteResultats";
import Papa from "papaparse";

export default {
  components: {
    TopBar,
    TableauResultats,
    SelectionCourse,
    FullScreenLoading,
    AttenteResultats,
  },

  data() {
    return {
      loading: true,
      id_epreuve: 0,
      type_course: "normal",
      course: "",
      current_passage: "",
      current_challenge: "",
      current_rassemblement: "",
      epreuve: {},
      resultats_equipes: [],
      resultats_for_pdf: [],
      list_cat: [],
      filterCat: "Toutes",
      list_clubs: [],
      filterClub: "Tous",
      filterSexe: "",
      keyword: "",
    };
  },
  computed: {
    resultats() {
      if (!this.epreuve.resultats) {
        return [];
      }
      var filteredTab = this.epreuve.resultats;

      if (this.keyword) {
        if (!isNaN(this.keyword)) {
          filteredTab = filteredTab.filter((item) => item.numero.includes(this.keyword));
        } else {
          filteredTab = filteredTab.filter((item) => item.nom.includes(this.keyword.toUpperCase()));
        }
      }
      if (this.filterSexe) {
        filteredTab = filteredTab.filter((item) => item.sexe.includes(this.filterSexe));
      }
      if (this.filterClub != "" && this.filterClub != "Tous") {
        filteredTab = filteredTab.filter((item) => item.club.includes(this.filterClub));
      }
      if (this.filterCat != "" && this.filterCat != "Toutes") {
        filteredTab = filteredTab.filter((item) => item.abbrev_categorie == this.filterCat);
      }
      for (var i = 0; i < filteredTab.length; i++) {
        if (filteredTab[i].champs_affiches[0] === undefined) {
          filteredTab.splice(i, 1);
        }
      }
      return filteredTab;
    },
  },
  watch: {
    $route: function (newVal, oldVal) {
      // watch it
      this.loading = true;
      this.init();
      this.loadDatas();
    },
  },
  methods: {
    /* Build data for PDF Export */
    itemsForPdf() {
      var iPDF = [];
      for (var i = 0; i < this.resultats.length; i++) {
        var c = this.resultats[i];
        iPDF.push([c["Clt"], c["Nom - Prénom"], c["Doss."], c["Clt Cat"], c["Temps"], c["Club"], c["nation"], c["Moy."], this.getFirst(c["Temps"]), c["sexe"], c["Clt Sexe"]]);
      }
      return iPDF;
    },
    itemsEquipesForPdf() {
      var iEPDF = [];
      for (var i = 0; i < this.resultats_equipes.length; i++) {
        var equipe = this.resultats_equipes[i];
        var coureurs = [];
        for (var j = 0; j < equipe.coureurs.length; j++) {
          var c = equipe.coureur[j];
          coureurs.push([c["Clt"], c["Nom - Prénom"], c["Doss."], c["Clt Cat"], c["Temps"], c["Club"], c["nation"], c["Moy."], this.getFirst(c["Temps"]), c["sexe"], c["Clt Sexe"]]);
        }
        equipe.coureurs = coureurs;
        iEPDF.push(equipe);
      }
      return iEPDF;
    },
    /* Build data for CSV Export */
    downloadCSV() {
      var dataToCsv = [];
      for (var i = 0; i < this.resultats.length; i++) {
        var r = this.resultats[i];
        var currentFields = this.epreuve.fields;
        var currentData = {};
        for (var j = 0; j < currentFields.length; j++) {
          if (currentFields[j].label === "Ecart") {
            currentData[currentFields[j].label] = this.getFirst(r["Temps"]);
          } else {
            currentData[currentFields[j].label] = r[currentFields[j].label];
          }
        }
        dataToCsv.push(currentData);
      }

      var csv = Papa.unparse(dataToCsv, { delimiter: ";" });

      var csvData = new Blob(["\ufeff", csv], {
        type: "text/csv;charset=utf-8;",
      });
      var csvURL = null;
      if (navigator.msSaveBlob) {
        csvURL = navigator.msSaveBlob(csvData, "download.csv");
      } else {
        csvURL = window.URL.createObjectURL(csvData);
      }

      var tempLink = document.createElement("a");
      tempLink.href = csvURL;
      tempLink.setAttribute("download", "Résultats-Sportips " + this.epreuve.course + ".csv");
      tempLink.click();
    },
    /* Return time since first runner arrival */
    getFirst(t) {
      if (!this.resultats.length > 0) {
        return 0;
      }
      if (t === this.resultats[0].temps_arrondi || t == null) {
        return "";
      } else {
        var t2 = this.resultats[0].temps_arrondi.split(":");
        var t1 = t.split(":");
        var diff = parseInt(t1[0]) * 3600 + parseInt(t1[1]) * 60 + parseInt(t1[2]) - (parseInt(t2[0]) * 3600 + parseInt(t2[1]) * 60 + parseInt(t2[2]));
        var heure = Math.floor(diff / 3600);
        var heurerest = diff % 3600;
        var minute = Math.floor(heurerest / 60);
        var sec = heurerest % 60;
        var res = "+ " + heure + "h" + minute + "m" + sec + "s";

        return res;
      }
    },
    /* Fetch data from server */
    loadDatas() {
      var _this = this;
      axios.post(this.$store.getters.base_url + "/public/rassemblement/get.php?id=" + this.id_epreuve + "&rassemblement=" + this.current_rassemblement).then(function (response) {
        _this.loading = false;
        _this.epreuve = response.data;

        if (_this.course === "") {
          _this.course = _this.epreuve.list_courses[0];
        }
        _this.build_lists_filters();
      });
    },

    /* Créer les liste de categories et clubs pour les filtres */
    build_lists_filters() {
      for (var i = 0; i < this.epreuve.resultats.length; i++) {
        if (!this.list_cat.includes(this.epreuve.resultats[i].abbrev_categorie)) {
          this.list_cat.push(this.epreuve.resultats[i].abbrev_categorie);
        }
        if (!this.list_clubs.includes(this.epreuve.resultats[i].club)) {
          this.list_clubs.push(this.epreuve.resultats[i].club);
        }
      }
      this.list_cat.sort();
      this.list_clubs.sort();
      this.list_cat.unshift("Toutes");
      this.list_clubs.unshift("Tous");
    },
    /* Initialize variables */
    init() {
      this.course = "";
      this.current_passage = "";
      this.current_rassemblement = "";
      this.current_challenge = "";
      this.current_challenge_equipe = "";
      this.current_courses_cumul = "";
      this.current_courses_cumul_equipe = "";
      this.id_epreuve = this.$route.query.id;
      if (this.$route.query.p) {
        this.course = this.$route.query.p;
      }

      if (this.$route.query.i) {
        this.current_passage = this.$route.query.i;
      }
      if (this.$route.query.r) {
        this.current_rassemblement = this.$route.query.r;
      }
      if (this.$route.query.c) {
        this.current_challenge = this.$route.query.c;
      }
      if (this.$route.query.ce) {
        this.current_challenge_equipe = this.$route.query.ce;
      }
      if (this.$route.query.cc) {
        this.current_courses_cumul = this.$route.query.cc;
      }
      if (this.$route.query.cce) {
        this.current_courses_cumul_equipe = this.$route.query.cce;
      }
      this.list_cat = [];
      this.list_clubs = [];
    },
  },
  mounted: function () {
    const current_query = { ...this.$route.query };
    this.$router.replace({ path: '/epreuve', query: current_query });
    this.init();
    this.loadDatas();
  },
};
</script>

<style>
.isCurrent {
  background-color: white !important;
  color: #f29406 !important;
}

#additional-informations-bar {
  margin-bottom: 5px;
}

#additional-informations-bar p {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0;
  text-align: left;
  padding-left: 15px;
}

#tableau-resultats {
  font-size: 14px;
}

#table_equipe {
  margin-top: 10px !important;
}

#tableau-resultats td {
  vertical-align: center;
}

.filter-title {
  font-size: 13px;
  margin-bottom: 10px;
  font-weight: bold;
}

#selector-bar {
  background-color: #e2e2e2;
  border: 1px solid #d8d7d7;
  border-radius: 3px;
  margin: 10px 5px;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
